// packages
import { createFeed, createRaceFeed } from './stores.js';
import {
  renderSvelteComponent,
  findSvelteComponentContainers,
  findSvelteComponentContainer,
} from './utils/render.js';

//components
import Props from './components/Props.svelte';
import Results from './components/Results.svelte';
import LocalResults from './components/LocalResults.svelte';

// URL for alpha and pub
import {
  STATE_URL,
  LA_COUNTY_URL,
  SD_URL,
  OC_URL,
  USHOUSE_URL,
} from './constants.js';

const FEED_TYPE_TO_URL = {
  state: STATE_URL,
  los_angeles: LA_COUNTY_URL,
  san_diego: SD_URL,
  orange_county: OC_URL,
  us_house: USHOUSE_URL,
};

async function main() {
  const containers = findSvelteComponentContainers('.race-embed-container');
  for (let i = 0; i < containers.length; i++) {
    const container = containers[i];
    const feedType = container.dataset.feed;
    const feedUrl = FEED_TYPE_TO_URL[feedType];
    const feed = await createFeed(feedUrl);

    // Populate races within container
    const elements = container.querySelectorAll('.race-result');
    if (elements.length) {
      elements.forEach((element) => {
        const raceId = element.id;
        const raceType = element.dataset.type;
        const raceFeed = /**  @type {import('./types.js').RaceFeed}  */ (
          createRaceFeed(feed, raceId)
        );

        if (raceType == 'result') {
          renderSvelteComponent(Results, /** @type {HTMLElement} */ element, {
            feed: raceFeed,
            face: false,
            crosswalk: '',
          });
        } else if (raceType == 'proposition') {
          renderSvelteComponent(Props, /** @type {HTMLElement} */ element, {
            feed: raceFeed,
          });
        } else if (raceType == 'local_result') {
          renderSvelteComponent(
            LocalResults,
            /** @type {HTMLElement} */ element,
            {
              feed: raceFeed,
            }
          );
        }
      });
    }
  }

  /**
   * dropdown select
   * @param {Event} e
   * @param {string} section
   */
  function filterDropdown(e, section) {
    // value of dropdown
    let value = e.detail.value;
    // get the class for the elements we want
    const itemClass =
      section == 'cities'
        ? '.cities-race-result-item'
        : '.school-boards-race-result-item';

    // find relevant board
    const resultsEl =
      section == 'cities'
        ? findSvelteComponentContainer('#race-embed-container--cities')
        : findSvelteComponentContainer('#race-embed-container--school-boards');

    if (!resultsEl) return;

    // select all Elements that match
    let findItems = resultsEl.querySelectorAll(itemClass);
    // filter!
    findItems.forEach((e) => {
      if (!e.parentElement) {
        return;
      }

      if (value == 'show_all') {
        e.parentElement.classList.remove('hidden');
        e.parentElement.setAttribute('aria-hidden', 'false');
        e.classList.remove('hidden');
        e.setAttribute('aria-hidden', 'false');
      } else if (e.classList.contains(value)) {
        if (value == 'item-los-angeles' && section == 'cities') {
          // this is b/c l.a. is in a diff container
          e.parentElement.classList.remove('hidden');
          e.parentElement.setAttribute('aria-hidden', 'false');
        }
        e.classList.remove('hidden');
        e.setAttribute('aria-hidden', 'false');
      } else {
        if (value == 'item-los-angeles' && section == 'cities') {
          // this is b/c l.a. is in a diff container
          e.parentElement.classList.add('hidden');
          e.parentElement.setAttribute('aria-hidden', 'false');
        }
        e.classList.add('hidden');
        e.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // city races
  let cityDropdown = findSvelteComponentContainer('select.cities');
  cityDropdown?.addEventListener('change', (event) => {
    // Custom event to get through shadow DOM
    const filterEvent = new CustomEvent('filter-dropdown', {
      detail: { value: event.target.value || '' },
    });
    filterDropdown(filterEvent, 'cities');
  });

  // school board races
  let schoolsDropdown = findSvelteComponentContainer('select.school-boards');
  schoolsDropdown?.addEventListener('change', (event) => {
    // Custom event to get through shadow DOM
    const filterEvent = new CustomEvent('filter-dropdown', {
      detail: { value: event.target.value || '' },
    });
    filterDropdown(filterEvent, 'school-boards');
  });
}

main().catch(console.error);
